import Skeleton from "react-loading-skeleton"

const TurnSkt = ({ count }) => {

    return (
        Array(count).fill(0).map((_, index) =>

            <div key={index} className="col">

                <div className="border-gray-300 border-radius-8 bg-white p-2">

                    <div className="d-flex justify-content-between gap-1">

                        <div className="d-flex justify-content-between flex-grow-1 flex-shrink-1 align-items-center  border-radius-8 background-bootstrap-gray-100  p-2 col-lg-9 ">
                            <Skeleton />
                        </div>

                        <div className="d-flex gap-2 position-relative">

                            <div
                                className="border-radius-8 tw-w-10 p-2 border-gray-300 background-bootstrap-gray-100">
                                <Skeleton />
                            </div>

                            <div className="border-radius-8 tw-w-10 p-2 border-gray-300 background-bootstrap-gray-100 ">
                                <Skeleton />
                            </div>

                        </div>

                    </div>

                    <div className="d-flex justify-content-between mt-2 border-radius-8 p-2 border-gray-300 background-bootstrap-gray-100">
                        <div>
                            <Skeleton />
                        </div>
                        <div className="d-flex gap-2">
                            <Skeleton />
                        </div>
                    </div>

                    <div className="d-flex flex-column mt-2 tw-gap-2">

                        <div className="w-100 m-auto row row-cols-2 align-items-center">

                            <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                                <Skeleton />
                            </span>

                            <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                                <Skeleton />
                            </span>

                        </div>

                        <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                            <Skeleton />
                        </div>

                        <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                            <Skeleton />
                        </div>

                        <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                            <Skeleton />
                        </div>

                        <div className="d-flex gap-2 ps-2 mb-4 mt-2">

                            <span className="visitTimeTurn border-radius-24 background-bootstrap-gray-200 fw-normal fs-12 color-bootstrap-gray-700">
                                <Skeleton />
                            </span>

                            <Skeleton />

                            <span className="visitTimeTurn border-radius-24 background-bootstrap-gray-200 fw-normal fs-12 color-bootstrap-gray-700">
                                <Skeleton />
                            </span>

                        </div>

                    </div>

                    <div className="d-flex gap-2 align-items-center justify-content-center mt-auto mx-2">
                        <button className="buttonApplyVisit col-4 border-radius-8 border-0">
                            <Skeleton />
                        </button>
                        <button className="buttonApplyVisit col-4 border-radius-8 border-0">
                            <Skeleton />
                        </button>
                        <button className="buttonApplyVisit col-4 border-radius-8 border-0">
                            <Skeleton />
                        </button>
                    </div>

                </div>

            </div>
        )
    )
}

export default TurnSkt